/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Resource from "../../../Resource";
import Prompt, {PromptControl} from "../../../Components/Prompt";
import PropTypes from "prop-types";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Input from "../../../Components/Control/Input";
import moment from "jalali-moment";
import ModalRequestProduct from "../ModalRequestProduct";
import ModalRequestProductScan from "../ModalRequestProductScan";
import Notif from "../../../Components/Notif";
import Org from "../../../Server/Org";

class ModalRequestProducts extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            grid: {
                defaultColDef: {
                    floatingFilter: false
                },
                columnDefs: [{
                    field: 'productNumber',
                    headerName: 'شماره فرآورده',
                    headerTooltip: 'شماره فرآورده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'bloodGroupStr',
                    headerName: 'گروه خونی',
                    headerTooltip: 'گروه خونی'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده'
                }, {
                    field: 'expireDate',
                    headerName: 'تاریخ انقضا',
                    headerTooltip: 'تاریخ انقضا',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date')
                }, {
                    field: 'collectionDate',
                    headerName: 'تاریخ جمع‌آوری',
                    headerTooltip: 'تاریخ جمع‌آوری',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date')
                }, {
                    field: 'state',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: this.props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state',
                    valueGetter: row => {
                        // const filters = [row.data.statusStr];

                        // return filters;
                    }
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: this.props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 150,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],// تو تابع open تعریف میشه چون دو تا حالت داریم
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {/*{row.data.statusId === 20 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>}*/}
                            {/*{row.data.statusId === 24 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>}*/}
                            {/*{row.data.formTypeId === 1 && <GridState theme={'green'}>عادی</GridState>}*/}
                            {/*{row.data.formTypeId === 2 && <GridState theme={'red'}>اورژانسی</GridState>}*/}
                            {/*{row.data.formTypeId === 3 && <GridState theme={'red'}>خون شسته</GridState>}*/}
                            {/*{row.data.formTypeId === 4 && <GridState theme={'red'}>خون اشعه‌دیده</GridState>}*/}
                            {/*{row.data.formTypeId === 5 && <GridState theme={'red'}>اورژانسی از سازمان</GridState>}*/}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            <GridButton type={"button"} theme={'view'} title={'مشاهده'} onClick={this.view.bind(this, row.data)}/>
                            <GridButton type={"button"} theme={'edit'} title={'ویرایش'} onClick={this.edit.bind(this, row.data)}/>
                            <GridButton type={"button"} theme={'delete'} title={'حذف'} onClick={this.delete.bind(this, row.data)}/>
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [
                            // {
                            // name: 'مشاهده درخواست',
                            // icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EYE.BLACK}" alt="">`,
                            // action: this.view.bind(this, params.node.data)
                            // }, {
                            //     name: 'تایید درخواست',
                            //     icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CHECK.BLACK}" alt="">`,
                            //     action: this.confirm.bind(this, params.node.data),
                            //     disabled: !this.Perms[params.node.data.formTypeId].CONFIRM
                            // }, {
                            //     name: 'تعیین گروه خونی',
                            //     icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CHECK.BLACK}" alt="">`,
                            //     action: this.accept.bind(this, params.node.data),
                            //     disabled: !this.Perms[params.node.data.formTypeId].SET_BLOOD_GROUP
                            // }, {
                            //     name: 'حذف درخواست',
                            //     icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CANCEL.BLACK}" alt="">`,
                            //     action: this.reject.bind(this, params.node.data),
                            //     disabled: !this.Perms[params.node.data.formTypeId].REJECT
                            // },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'yellow'}>در انتظار تحویل درخواست</GridState> درخواست رسیده از بخش در انتظار تحویل می باشد. (بعد از تحویل درخواست بخش اجازه ویرایش درخواست را ندارد.)</p>
                                <p><GridState theme={'yellow'}>در انتظار تعیین گروه خونی</GridState> درخواست رسیده از بخش در انتظار تعیین گروه خونی نمونه بیمار می باشد. (بعد از تعیین گروه خونی نمونه خون بیمار درخواست از لیست انتظار خارج شده و به ککارتابل اصلی منتقل می شود.)</p>
                                <p><GridState theme={'green'}>عادی</GridState> درخواست فرآورده از نوع عادی می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی</GridState> درخواست فرآورده از نوع اورژانسی می باشد.</p>
                                <p><GridState theme={'red'}>خون شسته</GridState> درخواست فرآورده از نوع خون شسته می باشد.</p>
                                <p><GridState theme={'red'}>خون اشعه‌دیده</GridState> درخواست فرآورده از نوع خون اشعه دیده می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی از سازمان</GridState> درخواست فرآورده از سازمان با وضعیت اورژانسی می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'view'} title={'مشاهده'}/> در صورت نیاز به مشاهده درخواست می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'blue'} title={'تایید'} icon={Resource.IMAGE.PACK.CHECK.WHITE}/> جهت صلب دسترسی بخش از ویرایش درخواست بایستی بعد از مشاهده، درخواست تایید شود.</p>
                                <p><GridButton theme={'accept'} title={'تعیین'}/> پس از تعیین گروه خونی از این طریق نسبت به ثبت آن اقدام نمایید تا درخواست به کارتابل اصلی منتقل شود.</p>
                                <p><GridButton theme={'delete'} title={'حذف'}/> در صورتی نیاز به حذف درخواست می توانید از این طریق اقدام نمایید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null,
            updated: false // checks if modal has been updated so the parent need reload or not
        };

        this.ref = {
            grid: React.createRef(),
            modal: React.createRef(),
            prompt: React.createRef(),
            modalRequestProduct: React.createRef(),
            modalRequestProductScan: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        const {state, props} = this;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalRequestProducts'}
                   size={'large'}
                   title={'آماده سازی درخواست'}
                   style={{height: 'calc(100vh - 60)'}}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <Group className={'ModalRequestProducts-group fb-20'}>
                        <div className={'dis-f'}>
                            <Input className={'pad-4 fb-5'} label={'نام بیمارستان'} readOnly={true} value={state.data?.hospitalFullName}/>
                            <Input className={'pad-4 fb-5'} label={'تاریخ درخواست'} readOnly={true} align={"center"} value={state.data?.createDateTime ? moment(state.data?.createDateTime).format('jYYYY/jMM/jDD HH:mm') : ''}/>
                            <div className="flex"/>
                            <div className={'fb-10 dis-f'}>
                                <Button className={'mar-4'} theme={'blue'} onClick={this.insertProductClickHandler.bind(this)}>ثبت فرآورده</Button>
                                <Button className={'mar-4'} theme={'green'} onClick={this.scanProductClickHandler.bind(this)}>اسکن فرآورده</Button>
                            </div>
                        </div>
                        <div className={'needs-list  mar-b-4'}>
                            {state.needs?.map(item => <Card onClick={this.needItemClickHandler.bind(this, item)} {...item}>{props.base.bloodGroupsById[item.bloodGroupId]?.shortName} {props.base.productTypesById[item.productTypeId]?.shortName}</Card>)}
                        </div>
                        <Grid refer={this.ref.grid } id={'requestProducts'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
                    </Group>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <Prompt ref={this.ref.prompt}/>
            <ModalRequestProduct refer={this.ref.modalRequestProduct} onSuccess={this.updateGrid.bind(this)}/>
            <ModalRequestProductScan refer={this.ref.modalRequestProductScan} onSuccess={this.updateGrid.bind(this)}/>
        </React.Fragment>;
    }

    updateGrid(closeIfEmpty = false) {
        this.ref.grid.current.loading();

        Org.requestData({hospitalRequestId: this.state.data.hospitalRequestId})
            .then(data => {
                this.ref.grid.current.loading(false);

                this.setState({
                    rowData: data.requestProducts || [],
                    needs: this.getNeedProducts(data),
                    data: {
                        ...this.state.data,
                        ...data
                    }
                });
            })
            .catch(message => {
                console.log(message);
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    close() {
        this.ref.modal.current.close();

        if (this.state.updated)
            this.props.onSuccess();

        this.props.onClose();
    }

    delete(row, props = {loading: _ => null}) {
        console.log(this.state)
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید فرآورده مورد نظر را از لیست حذف کنید؟',
            buttons: PromptControl.YES_NO,
            onClose: button => {
                if (button.id === PromptControl.YES) {
                    props.loading();

                    Org.deleteProductFromRequest({
                        hospitalRequestId: this.state.data?.hospitalRequestId,
                        orgProductId: row?.orgProductId
                    }).then(_ => {
                        this.updateGrid();

                        new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();

                        props.loading(false);
                    }).catch(message => {
                        new Notif({message, theme: 'error'}).show();
                        props.loading(false);
                    });
                }
            }
        });
    };

    edit(row, props = {loading: _ => null}) {
        this.ref.modalRequestProduct.current.open(row, ModalAction.UPDATE);
    }

    getNeedProducts(data) {
        const needs = {}

        // 1A+ 2B+ 3AB+ 4O+ 5A- 6B- 7AB- 8O-
        // 1WB 2RBC 3LRBC 4PRBC 5plt 6lrplt 7ffp 8cpp 9cry 10WRBC 11RRBC 12FPLT
        if (data?.wbJson?.a_POSCount || data?.wb?.a_POSCount) needs['1|1'] = {bloodGroupId: 1, productTypeId: 1, count: data?.wbJson?.a_POSCount || data?.wb?.a_POSCount};
        if (data?.rbcJson?.a_POSCount || data?.rbc?.a_POSCount) needs['1|2'] = {bloodGroupId: 1, productTypeId: 2, count: data?.rbcJson?.a_POSCount || data?.rbc?.a_POSCount};
        if (data?.lrbcJson?.a_POSCount) needs['1|3'] = {bloodGroupId: 1, productTypeId: 3, count: data?.lrbcJson?.a_POSCount};
        if (data?.pediatrictRBCJson?.a_POSCount) needs['1|4'] = {bloodGroupId: 1, productTypeId: 4, count: data?.pediatrictRBCJson?.a_POSCount};
        if (data?.pltJson?.a_POSCount || data?.plt?.a_POSCount) needs['1|5'] = {bloodGroupId: 1, productTypeId: 5, count: data?.pltJson?.a_POSCount || data?.plt?.a_POSCount};
        if (data?.lrpltJson?.a_POSCount) needs['1|6'] = {bloodGroupId: 1, productTypeId: 6, count: data?.lrpltJson?.a_POSCount};
        if (data?.ffpJson?.a_POSCount || data?.ffp?.a_POSCount) needs['1|7'] = {bloodGroupId: 1, productTypeId: 7, count: data?.ffpJson?.a_POSCount || data?.ffp?.a_POSCount};
        if (data?.cppJson?.a_POSCount) needs['1|8'] = {bloodGroupId: 1, productTypeId: 8, count: data?.cppJson?.a_POSCount};
        if (data?.cryJson?.a_POSCount || data?.cry?.a_POSCount) needs['1|9'] = {bloodGroupId: 1, productTypeId: 9, count: data?.cryJson?.a_POSCount || data?.cry?.a_POSCount};

        if (data?.wbJson?.b_POSCount || data?.wb?.b_POSCount) needs['2|1'] = {bloodGroupId: 2, productTypeId: 1, count: data?.wbJson?.b_POSCount || data?.wb?.b_POSCount};
        if (data?.rbcJson?.b_POSCount || data?.rbc?.b_POSCount) needs['2|2'] = {bloodGroupId: 2, productTypeId: 2, count: data?.rbcJson?.b_POSCount || data?.rbc?.b_POSCount};
        if (data?.lrbcJson?.b_POSCount) needs['2|3'] = {bloodGroupId: 2, productTypeId: 3, count: data?.lrbcJson?.b_POSCount};
        if (data?.pediatrictRBCJson?.b_POSCount) needs['2|4'] = {bloodGroupId: 2, productTypeId: 4, count: data?.pediatrictRBCJson?.b_POSCount};
        if (data?.pltJson?.b_POSCount || data?.plt?.b_POSCount) needs['2|5'] = {bloodGroupId: 2, productTypeId: 5, count: data?.pltJson?.b_POSCount || data?.plt?.b_POSCount};
        if (data?.lrpltJson?.b_POSCount) needs['2|6'] = {bloodGroupId: 2, productTypeId: 6, count: data?.lrpltJson?.b_POSCount};
        if (data?.ffpJson?.b_POSCount || data?.ffp?.b_POSCount) needs['2|7'] = {bloodGroupId: 2, productTypeId: 7, count: data?.ffpJson?.b_POSCount || data?.ffp?.b_POSCount};
        if (data?.cppJson?.b_POSCount) needs['2|8'] = {bloodGroupId: 2, productTypeId: 8, count: data?.cppJson?.b_POSCount};
        if (data?.cryJson?.b_POSCount || data?.cry?.b_POSCount) needs['2|9'] = {bloodGroupId: 2, productTypeId: 9, count: data?.cryJson?.b_POSCount || data?.cry?.b_POSCount};

        if (data?.wbJson?.aB_POSCount || data?.wb?.aB_POSCount) needs['3|1'] = {bloodGroupId: 3, productTypeId: 1, count: data?.wbJson?.aB_POSCount || data?.wb?.aB_POSCount};
        if (data?.rbcJson?.aB_POSCount || data?.rbc?.aB_POSCount) needs['3|2'] = {bloodGroupId: 3, productTypeId: 2, count: data?.rbcJson?.aB_POSCount || data?.rbc?.aB_POSCount};
        if (data?.lrbcJson?.aB_POSCount) needs['3|3'] = {bloodGroupId: 3, productTypeId: 3, count: data?.lrbcJson?.aB_POSCount};
        if (data?.pediatrictRBCJson?.aB_POSCount) needs['3|4'] = {bloodGroupId: 3, productTypeId: 4, count: data?.pediatrictRBCJson?.aB_POSCount};
        if (data?.pltJson?.aB_POSCount || data?.plt?.aB_POSCount) needs['3|5'] = {bloodGroupId: 3, productTypeId: 5, count: data?.pltJson?.aB_POSCount || data?.plt?.aB_POSCount};
        if (data?.lrpltJson?.aB_POSCount) needs['3|6'] = {bloodGroupId: 3, productTypeId: 6, count: data?.lrpltJson?.aB_POSCount};
        if (data?.ffpJson?.aB_POSCount || data?.ffp?.aB_POSCount) needs['3|7'] = {bloodGroupId: 3, productTypeId: 7, count: data?.ffpJson?.aB_POSCount || data?.ffp?.aB_POSCount};
        if (data?.cppJson?.aB_POSCount) needs['3|8'] = {bloodGroupId: 3, productTypeId: 8, count: data?.cppJson?.aB_POSCount};
        if (data?.cryJson?.aB_POSCount || data?.cry?.aB_POSCount) needs['3|9'] = {bloodGroupId: 3, productTypeId: 9, count: data?.cryJson?.aB_POSCount || data?.cry?.aB_POSCount};

        if (data?.wbJson?.o_POSCount || data?.wb?.o_POSCount) needs['4|1'] = {bloodGroupId: 4, productTypeId: 1, count: data?.wbJson?.o_POSCount || data?.wb?.o_POSCount};
        if (data?.rbcJson?.o_POSCount || data?.rbc?.o_POSCount) needs['4|2'] = {bloodGroupId: 4, productTypeId: 2, count: data?.rbcJson?.o_POSCount || data?.rbc?.o_POSCount};
        if (data?.lrbcJson?.o_POSCount) needs['4|3'] = {bloodGroupId: 4, productTypeId: 3, count: data?.lrbcJson?.o_POSCount};
        if (data?.pediatrictRBCJson?.o_POSCount) needs['4|4'] = {bloodGroupId: 4, productTypeId: 4, count: data?.pediatrictRBCJson?.o_POSCount};
        if (data?.pltJson?.o_POSCount || data?.plt?.o_POSCount) needs['4|5'] = {bloodGroupId: 4, productTypeId: 5, count: data?.pltJson?.o_POSCount || data?.plt?.o_POSCount};
        if (data?.lrpltJson?.o_POSCount) needs['4|6'] = {bloodGroupId: 4, productTypeId: 6, count: data?.lrpltJson?.o_POSCount};
        if (data?.ffpJson?.o_POSCount || data?.ffp?.o_POSCount) needs['4|7'] = {bloodGroupId: 4, productTypeId: 7, count: data?.ffpJson?.o_POSCount || data?.ffp?.o_POSCount};
        if (data?.cppJson?.o_POSCount) needs['4|8'] = {bloodGroupId: 4, productTypeId: 8, count: data?.cppJson?.o_POSCount};
        if (data?.cryJson?.o_POSCount || data?.cry?.o_POSCount) needs['4|9'] = {bloodGroupId: 4, productTypeId: 9, count: data?.cryJson?.o_POSCount || data?.cry?.o_POSCount};

        if (data?.wbJson?.a_NEGCount || data?.wb?.a_NEGCount) needs['5|1'] = {bloodGroupId: 5, productTypeId: 1, count: data?.wbJson?.a_NEGCount || data?.wb?.a_NEGCount};
        if (data?.rbcJson?.a_NEGCount || data?.rbc?.a_NEGCount) needs['5|2'] = {bloodGroupId: 5, productTypeId: 2, count: data?.rbcJson?.a_NEGCount || data?.rbc?.a_NEGCount};
        if (data?.lrbcJson?.a_NEGCount) needs['5|3'] = {bloodGroupId: 5, productTypeId: 3, count: data?.lrbcJson?.a_NEGCount};
        if (data?.pediatrictRBCJson?.a_NEGCount) needs['5|4'] = {bloodGroupId: 5, productTypeId: 4, count: data?.pediatrictRBCJson?.a_NEGCount};
        if (data?.pltJson?.a_NEGCount || data?.plt?.a_NEGCount) needs['5|5'] = {bloodGroupId: 5, productTypeId: 5, count: data?.pltJson?.a_NEGCount || data?.plt?.a_NEGCount};
        if (data?.lrpltJson?.a_NEGCount) needs['5|6'] = {bloodGroupId: 5, productTypeId: 6, count: data?.lrpltJson?.a_NEGCount};
        if (data?.ffpJson?.a_NEGCount || data?.ffp?.a_NEGCount) needs['5|7'] = {bloodGroupId: 5, productTypeId: 7, count: data?.ffpJson?.a_NEGCount || data?.ffp?.a_NEGCount};
        if (data?.cppJson?.a_NEGCount) needs['5|8'] = {bloodGroupId: 5, productTypeId: 8, count: data?.cppJson?.a_NEGCount};
        if (data?.cryJson?.a_NEGCount || data?.cry?.a_NEGCount) needs['5|9'] = {bloodGroupId: 5, productTypeId: 9, count: data?.cryJson?.a_NEGCount || data?.cry?.a_NEGCount};

        if (data?.wbJson?.b_NEGCount || data?.wb?.b_NEGCount) needs['6|1'] = {bloodGroupId: 6, productTypeId: 1, count: data?.wbJson?.b_NEGCount || data?.wb?.b_NEGCount};
        if (data?.rbcJson?.b_NEGCount || data?.rbc?.b_NEGCount) needs['6|2'] = {bloodGroupId: 6, productTypeId: 2, count: data?.rbcJson?.b_NEGCount || data?.rbc?.b_NEGCount};
        if (data?.lrbcJson?.b_NEGCount) needs['6|3'] = {bloodGroupId: 6, productTypeId: 3, count: data?.lrbcJson?.b_NEGCount};
        if (data?.pediatrictRBCJson?.b_NEGCount) needs['6|4'] = {bloodGroupId: 6, productTypeId: 4, count: data?.pediatrictRBCJson?.b_NEGCount};
        if (data?.pltJson?.b_NEGCount || data?.plt?.b_NEGCount) needs['6|5'] = {bloodGroupId: 6, productTypeId: 5, count: data?.pltJson?.b_NEGCount || data?.plt?.b_NEGCount};
        if (data?.lrpltJson?.b_NEGCount) needs['6|6'] = {bloodGroupId: 6, productTypeId: 6, count: data?.lrpltJson?.b_NEGCount};
        if (data?.ffpJson?.b_NEGCount || data?.ffp?.b_NEGCount) needs['6|7'] = {bloodGroupId: 6, productTypeId: 7, count: data?.ffpJson?.b_NEGCount || data?.ffp?.b_NEGCount};
        if (data?.cppJson?.b_NEGCount) needs['6|8'] = {bloodGroupId: 6, productTypeId: 8, count: data?.cppJson?.b_NEGCount};
        if (data?.cryJson?.b_NEGCount || data?.cry?.b_NEGCount) needs['6|9'] = {bloodGroupId: 6, productTypeId: 9, count: data?.cryJson?.b_NEGCount || data?.cry?.b_NEGCount};

        if (data?.wbJson?.aB_NEGCount || data?.wb?.aB_NEGCount) needs['7|1'] = {bloodGroupId: 7, productTypeId: 1, count: data?.wbJson?.o_NEGCount || data?.wb?.o_NEGCount};
        if (data?.rbcJson?.aB_NEGCount || data?.rbc?.aB_NEGCount) needs['7|2'] = {bloodGroupId: 7, productTypeId: 2, count: data?.rbcJson?.o_NEGCount || data?.rbc?.o_NEGCount};
        if (data?.lrbcJson?.aB_NEGCount) needs['7|3'] = {bloodGroupId: 7, productTypeId: 3, count: data?.lrbcJson?.o_NEGCount};
        if (data?.pediatrictRBCJson?.aB_NEGCount) needs['7|4'] = {bloodGroupId: 7, productTypeId: 4, count: data?.pediatrictRBCJson?.o_NEGCount};
        if (data?.pltJson?.aB_NEGCount || data?.plt?.aB_NEGCount) needs['7|5'] = {bloodGroupId: 7, productTypeId: 5, count: data?.pltJson?.o_NEGCount || data?.plt?.aB_NEGCount};
        if (data?.lrpltJson?.aB_NEGCount) needs['7|6'] = {bloodGroupId: 7, productTypeId: 6, count: data?.lrpltJson?.o_NEGCount};
        if (data?.ffpJson?.aB_NEGCount || data?.ffp?.aB_NEGCount) needs['7|7'] = {bloodGroupId: 7, productTypeId: 7, count: data?.ffpJson?.o_NEGCount || data?.ffp?.aB_NEGCount};
        if (data?.cppJson?.aB_NEGCount) needs['7|8'] = {bloodGroupId: 7, productTypeId: 8, count: data?.cppJson?.o_NEGCount};
        if (data?.cryJson?.aB_NEGCount || data?.cry?.aB_NEGCount) needs['7|9'] = {bloodGroupId: 7, productTypeId: 9, count: data?.cryJson?.o_NEGCount || data?.cry?.aB_NEGCount};

        if (data?.wbJson?.o_NEGCount || data?.wb?.o_NEGCount) needs['8|1'] = {bloodGroupId: 8, productTypeId: 1, count: data?.wbJson?.o_NEGCount || data?.wb?.o_NEGCount};
        if (data?.rbcJson?.o_NEGCount || data?.rbc?.o_NEGCount) needs['8|2'] = {bloodGroupId: 8, productTypeId: 2, count: data?.rbcJson?.o_NEGCount || data?.rbc?.o_NEGCount};
        if (data?.lrbcJson?.o_NEGCount) needs['8|3'] = {bloodGroupId: 8, productTypeId: 3, count: data?.lrbcJson?.o_NEGCount};
        if (data?.pediatrictRBCJson?.o_NEGCount) needs['8|4'] = {bloodGroupId: 8, productTypeId: 4, count: data?.pediatrictRBCJson?.o_NEGCount};
        if (data?.pltJson?.o_NEGCount || data?.plt?.o_NEGCount) needs['8|5'] = {bloodGroupId: 8, productTypeId: 5, count: data?.pltJson?.o_NEGCount || data?.plt?.o_NEGCount};
        if (data?.lrpltJson?.o_NEGCount) needs['8|6'] = {bloodGroupId: 8, productTypeId: 6, count: data?.lrpltJson?.o_NEGCount};
        if (data?.ffpJson?.o_NEGCount || data?.ffp?.o_NEGCount) needs['8|7'] = {bloodGroupId: 8, productTypeId: 7, count: data?.ffpJson?.o_NEGCount || data?.ffp?.o_NEGCount};
        if (data?.cppJson?.o_NEGCount) needs['8|8'] = {bloodGroupId: 8, productTypeId: 8, count: data?.cppJson?.o_NEGCount};
        if (data?.cryJson?.o_NEGCount || data?.cry?.o_NEGCount) needs['8|9'] = {bloodGroupId: 8, productTypeId: 9, count: data?.cryJson?.o_NEGCount || data?.cry?.o_NEGCount};

        for (const item of data.requestProducts || []) {
            const key = `${item.bloodGroupId}|${item.productTypeId}`;

            if (needs[key]) {
                needs[key].count -= 1;
                needs[key].addedCount = (needs[key].addedCount || 0) + 1;
                // if (needs[key].count <= 1)
                //     delete needs[key];
                // else
                //     needs[key].count -= 1;
            }
        }

        return Object.values(needs);
    }

    insertProductClickHandler() {
        this.ref.modalRequestProduct.current.open({hospitalRequestId: this.state.data.hospitalRequestId}, ModalAction.INSERT);
    }

    needItemClickHandler(data) {
        this.ref.modalRequestProduct.current.open({
            hospitalRequestId: this.state.data.hospitalRequestId,
            bloodGroupId: [{id: data.bloodGroupId}],
            productTypeId: [{id: data.productTypeId}]
        }, ModalAction.INSERT);
    }

    open(data, action) {
        this.ref.modal.current.open();

        this.setState({data, action});
    }

    scanProductClickHandler() {
        this.ref.modalRequestProductScan.current.open({hospitalRequestId: this.state.data.hospitalRequestId}, ModalAction.SCAN);
    }

    view(row) {
        this.ref.modalRequestProduct.current.open(row, ModalAction.VIEW);
    }
}

class Card extends Component {
    render() {
        const {props} = this;
        const added = props.addedCount || 0;
        const total = added + props.count;
        let state = '';
        const percentage = {mid: Math.round(added * 100 / total)};
        percentage.start = percentage.mid - 5;
        percentage.end = percentage.mid + 5;

        if (percentage.mid === 0 || percentage.mid === 100) {
            percentage.start = percentage.mid;
            percentage.end = percentage.mid;
        }
        if (percentage.start < 0)
            percentage.start = 0;
        if (percentage.end > 100)
            percentage.end = 100;

        if (percentage.mid === 100)
            state = 'تکمیل';
        else if (percentage.mid < 100)
            state = `${props.count} واحد`;
        else if (percentage.mid > 100)
            state = 'مازاد';

        return <div onClick={props.onClick} className={'Card'} style={{background: `linear-gradient(90deg, var(--goo-yel-t) ${100 - percentage.end}%, var(--goo-gre-t) ${100 - percentage.start}%)`}}>{props.children} | <span>{state}</span></div>;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(ModalRequestProducts);